var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import colors, { background, border } from '../../../styles/colors';
import spacing from '../../../styles/spacing';
import stacking from '../../../styles/stacking';
import { breakpointObj } from '../../../styles/breakpoints';
import { keyframeFadeIn, keyframeSlideFromBottom, keyframeSlideFromRight, keyframeSlideBackFromRight } from '../../../styles/keyFrames';
var _ref = spacing,
  sp32 = _ref.sp32;
export var SLIDE_ANIMATION_DURATION = 200;
export var FADEIN_ANIMATION_DURATION = 300;
export var convertDurationToCSS = function convertDurationToCSS(duration) {
  return duration / 1000;
};
export var iconWidth = 32;
export var iconHeight = 32;
export var wrapperDesktopStyles = function wrapperDesktopStyles(props) {
  var animation = props.animation;
  var styles = /*#__PURE__*/css(["border:1px solid ", ";bottom:auto;position:relative;"], border.midGray);
  if (animation === 'slideFromRight') {
    styles = css(["position:fixed;bottom:0;top:0;right:0;width:400px;height:100%;"]);
  }
  return styles;
};
export var iconDesktopStyles = function iconDesktopStyles(props) {
  var animation = props.animation;
  var styles = /*#__PURE__*/css(["right:0;padding:0;top:", "px;"], -(iconHeight + 16));
  if (animation === 'slideFromRight') {
    styles = css(["top:16px;padding:0;left:-", "px;"], iconHeight + 16);
  }
  return styles;
};
export var scrollableContentDesktopStyles = function scrollableContentDesktopStyles(props) {
  var animation = props.animation;
  var styles = /*#__PURE__*/css(["max-height:calc(100vh - ", "px);"], 2 * (iconHeight + 32));
  if (animation === 'slideFromRight') {
    styles = css(["max-height:none;"]);
  }
  return styles;
};
export var mobileAnimation = function mobileAnimation(props) {
  var animation = props.animation;
  var keyframe = keyframeSlideFromBottom(iconHeight + 32);
  if (animation === 'slideFromRight') {
    keyframe = keyframeSlideFromBottom(iconHeight + 32);
  }
  return css(["", " ", "s ease-in-out;"], keyframe, convertDurationToCSS(SLIDE_ANIMATION_DURATION));
};
export var desktopAnimation = function desktopAnimation(props) {
  var animation = props.animation,
    closed = props.closed;
  var keyframe = /*#__PURE__*/css(["", " ", "s ease-in-out;"], keyframeFadeIn, convertDurationToCSS(FADEIN_ANIMATION_DURATION));
  if (animation === 'slideFromRight') {
    keyframe = css(["", " ", "s ease-in-out;"], keyframeSlideFromRight(iconHeight + 32), convertDurationToCSS(SLIDE_ANIMATION_DURATION));
    if (closed) {
      keyframe = css(["", " ", "s ease-in-out forwards;"], keyframeSlideBackFromRight(iconHeight + 32), convertDurationToCSS(SLIDE_ANIMATION_DURATION));
    }
  }
  return keyframe;
};
export var preventScroll = /*#__PURE__*/css(["position:fixed;overflow:hidden;width:100%;height:100%;"]);
export var Wrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__Wrapper",
  componentId: "sc-1yca42h-0"
})(["position:absolute;bottom:0;width:100%;max-width:", ";height:auto;background:", ";border:0;z-index:", ";box-sizing:border-box;animation:", ";max-height:100%;", ";"], function (_ref2) {
  var maxWidth = _ref2.maxWidth;
  return maxWidth ? "".concat(maxWidth, "px") : "".concat(breakpointObj.tabletLandscape, "px");
}, background.white, stacking.infront, mobileAnimation, function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.tabletPortrait(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n    animation: ", ";\n  "])), wrapperDesktopStyles, desktopAnimation);
});
export var CloseIconWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__CloseIconWrapper",
  componentId: "sc-1yca42h-1"
})(["position:absolute;right:6px;top:", "px;padding:10px;color:", ";width:", "px;height:", "px;cursor:pointer;box-sizing:initial;", ";"], -(iconHeight + 26), colors.white, iconWidth, iconHeight, function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.tabletPortrait(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", "\n  "])), iconDesktopStyles);
});
export var ScrollableContent = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__ScrollableContent",
  componentId: "sc-1yca42h-2"
})(["width:100%;height:100%;max-height:calc(100vh - 180px);overflow-y:auto;", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.tabletPortrait(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", ";\n  "])), scrollableContentDesktopStyles);
});
export var Frame = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__Frame",
  componentId: "sc-1yca42h-3"
})(["padding:", ";"], sp32);